import { other_field } from './other_field';

export function required_if(parameters, fields) {
  const value = parameters[1];
  const { other } = other_field(parameters, fields);
  return {
    other,
    value
  };
}
